import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { AuthService } from './auth.service';
import { SettingsService } from '../common/settings.service';
import 'rxjs/add/operator/map';
import { Supervisor, SupervisorUpdate } from '../../entity';

@Injectable()
export class HotelService {

	constructor(
		private http: Http,
		private authService: AuthService,
		private settings: SettingsService
	) { }

	getAllHotels() {
		const headers = new Headers();
		headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
		headers.append('Authorization', this.authService.getUserToken());

		return this.http.get(this.settings.serverNomenclator + 'Hotel/GetHotels', { headers: headers })
			.map(res => res.json());
	}

	addHotel(hotel: Supervisor) {
		const headers = new Headers();
		headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
		headers.append('Authorization', this.authService.getUserToken());

		return this.http.post(this.settings.serverNomenclator + 'Hotel/AddHotel', hotel, { headers: headers })
			.map(res => res.json());
	}

	getHotel(id: string) {
		const headers = new Headers();
		headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
		headers.append('Authorization', this.authService.getUserToken());

		return this.http.get(this.settings.serverNomenclator + 'Hotel/GetHotel?portalOperatorId=' + id, { headers: headers })
			.map(res => res.json());
	}

	editHotel(update: SupervisorUpdate) {
		const headers = new Headers();
		headers.append('LoginRole', `${this.authService.getUserLoginRole()}`);
		headers.append('Authorization', this.authService.getUserToken());
	
		return this.http.post(this.settings.serverNomenclator + 'Hotel/EditHotelProfile', update, { headers: headers })
		  .map(res => res.json());
	}
}
